import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoPncp } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ContratoPncpService extends BaseResourceService<ContratoPncp> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-pncp`, injector);
  }

  public buscarPendenciasPncp(orgao, exercicio): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/pendencia-pncp/${orgao}/${exercicio}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
